import Container from '@/container';
import {Col, Grid, Row} from '@/grid';
import {withBgYellow50} from '@/hocs/withColors';
import {withMarginBottomSm, withMarginBottomXxl} from '@/hocs/withSpacing';
import {SectionPadding} from '@/section';
import {H2, H3, P, PMarginSm, PNoMargin} from '@/typography';
import BoxGrid from '@/ui/box-grid';
import {GridItem, GridLayout} from '@/ui/grid/grid-layout';

const Yellow50Section = withBgYellow50(SectionPadding);
const MarginedSm = withMarginBottomSm('div');
const PmarginedXxl = withMarginBottomXxl(P);

const globalReachArray = [
  {
    shape: 'partner',
    title: 'Partner with purpose',
    copy: 'Whether you’re advising, investing, or building communities, partner with us to help businesses hire smarter and scale faster.'
  },
  {
    shape: 'award',
    title: 'Award-winning technology',
    copy: 'Help businesses start strong with proven hiring tools, and rapid onboarding.'
  },
  {
    shape: 'hassle',
    title: 'Hassle free program',
    copy: 'Use your referral link and code to spread the word. No complex agreements or hidden requirements.'
  }
];

const WhyWorkable = () => (
  <Yellow50Section>
    <Container>
      <Grid fluid>
        <Row center="xs">
          <Col xs={12} lg={8}>
            <H2>Why Workable is the right partner for you</H2>
            <PMarginSm>
              Workable is a trusted hiring platform used by thousands of companies worldwide. It is
              built to solve real challenges for modern teams. By partnering with us, you align with
              a product that is proven in the market, in demand by customers, and easy to position
              in a competitive landscape.{' '}
            </PMarginSm>
            <PmarginedXxl>
              Our partner program gives you everything you need to succeed, including sales
              enablement, marketing support, revenue-sharing opportunities, and a team committed to
              helping you grow.
            </PmarginedXxl>
          </Col>
        </Row>
        <GridLayout Col={3} lgCol={2} autoRows>
          {globalReachArray.map((item, index) => (
            <GridItem key={index}>
              <BoxGrid backgroundColor="var(--yellow100)">
                <MarginedSm>
                  <img
                    src={`/static/images/partnership-program/partner-with-workable/${item.shape}-shape.svg`}
                    alt={`${item.title} icon`}
                    loading="lazy"
                  />
                </MarginedSm>
                <H3>{item.title}</H3>
                <PNoMargin>{item.copy}</PNoMargin>
              </BoxGrid>
            </GridItem>
          ))}
        </GridLayout>
      </Grid>
    </Container>
  </Yellow50Section>
);

export default WhyWorkable;
